:host {
  display: block;
}

:host(.sellalong-panel-variant-mini) {
  max-width: 340px;
}

:host(.sellalong-panel--cart-empty) {
  display: none;
}

:host.hydrated {
  visibility: hidden;
}

:host > section {
  border-top: 1px solid #e2e2e2;
  visibility: visible;
}

.swiper {
  /* avoid user selecting text when trying to pan */
  user-select: none;
}

/* copy+paste from swiper.less */
.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}
.swiper-container-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}
.swiper-container-pointer-events {
  touch-action: pan-y;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.sellalong-panel-purchase-list {
  margin: 0 0 40px;
  padding: 0;
}

.sellalong-panel-heading {
  color: #000;
  font-family: var(--sellalong-heading-font, serif);
  font-size: var(--sellalong-heading-font-size, 32px);
  font-weight: var(--sellalong-heading-font-weight, normal);
  margin: 40px 0 20px;
}

.sellalong-panel-help-cta {
  display: inline-block;
  height: 24px;
  text-decoration: none;
  width: 24px;
  vertical-align: top;
  padding: 5px;
  margin-left: 5px;
}

.sellalong-panel-help-cta svg {
  display: block;
}

.sellalong-panel-help-cta svg g {
  fill: none;
}

.sellalong-panel-purchase-item {
  display: block;
  height: auto;
  width: 200px;
}

.sellalong-panel-steps {
  padding: 0;
  margin: 20px 0;
  font-family: sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.sellalong-panel-steps::after {
  content: " ";
  display: block;
  clear: both;
}

.sellalong-panel-steps > li {
  display: block;
  float: left;
  line-height: 26px;
}

.sellalong-panel-steps > li:nth-child(2) {
  margin: 0 32px;
}

@media screen and (max-width: 850px) {
  .sellalong-panel-steps > li {
    float: none;
  }

  .sellalong-panel-steps > li:nth-child(2) {
    margin: 0;
  }
}

.sellalong-panel-steps > li::before {
  display: inline-block;
  color: var(--sellalong-colour-primary, #000);
  font-size: 26px;
  font-family: sans-serif;
  vertical-align: middle;
  padding-right: 8px;
}

.sellalong-panel-steps > li:nth-child(1)::before {
  content: "\278a";
}

.sellalong-panel-steps > li:nth-child(2)::before {
  content: "\278b";
}

.sellalong-panel-steps > li:nth-child(3)::before {
  content: "\278c";
}

.sellalong-panel-nav {
  margin-bottom: 20px;
  text-align: center;
}

.sellalong-panel-nav--hide {
  display: none;
}

.sellalong-panel-nav--start .sellalong-panel-nav-prev {
  visibility: hidden;
}

.sellalong-panel-nav--end .sellalong-panel-nav-next {
  visibility: hidden;
}

.sellalong-panel-nav svg {
  fill: none;
  height: 32px;
  width: 32px;
}

.sellalong-panel-footer .sellalong-panel-footer__right {
  text-align: right;
}

.sellalong-panel-status,
.sellalong-panel-checkout-note {
  font-family: sans-serif;
  font-size: 16px;
  margin-bottom: 10px;
}

sellalong-powered-by {
  position: absolute;
}

.sellalong-panel-error {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sellalong-panel-error > p {
  font-family: sans-serif;
  font-size: 15px;
  margin: 0 0 10px;
  text-align: center;
}

.sellalong-panel-login {
  left: 50%;
  min-width: 220px;
  position: absolute;
  top: 25%;
  text-align: center;
  transform: translate(-50%, -50%);
  z-index: 100;
}

.sellalong-panel-login-start-cta {
  background-color: #fff;
}

.sellalong-panel-login > a {
  background-color: var(--sellalong-colour-primary, #000);
  border-radius: 3px;
  color: #fff;
  display: block;
  font-family: sans-serif;
  font-size: 15px;
  letter-spacing: 0.08em;
  margin: 0 20px 2px;
  padding: 17px 25px 13px;
  text-transform: uppercase;
  text-decoration: none;
}

.sellalong-panel-login > p {
  font-family: sans-serif;
  font-size: 15px;
}

.sellalong-panel-login > a:hover {
  background-color: var(--sellalong-colour-primary-tint, #333);
}

.sellalong-panel-continue-shopping {
  font-size: 20px;
}

.sellalong-panel-login-email {
  background-color: #fff;
}

@media screen and (max-width: 768px) {
  :host {
    margin-top: 0;
    padding-top: 40px;
    top: 0;
  }

  .sellalong-panel-heading {
    font-size: 26px;
    margin: 40px 0 10px;
  }

  .sellalong-panel-steps {
    margin: 10px 0;
  }

  .sellalong-panel-purchase-list {
    margin: 0 0 20px;
  }

  sellalong-powered-by {
    display: block;
    margin-bottom: 10px;
    position: static;
  }

  .sellalong-panel-footer__checkout-buttons input {
    width: 100%;
  }

  .sellalong-panel-login-cta {
    min-width: 240px;
  }

  .sellalong-panel-login-cta > a {
    margin: 0 0px 2px;
  }
}
